__turbopack_context__.v({
  "sortByFilterDropdownContents": "styles-module__LwOvIW__sortByFilterDropdownContents",
  "sortByFilterTrigger": "styles-module__LwOvIW__sortByFilterTrigger",
  "sortByFilterTriggerContainer": "styles-module__LwOvIW__sortByFilterTriggerContainer",
  "sortIcon": "styles-module__LwOvIW__sortIcon",
});
